module.exports = __webpack_public_path__ + "media/shard_blogs/kocpc-1f652a3f.jpg";